/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import React, {
  forwardRef,
  memo,
  useImperativeHandle
} from 'react';
import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {BulkActionEntity} from '@ion/core/src/types/entities';
import {BodyTypography} from '../../typography/BodyTypography';
import {HeaderTypography} from '../../typography/HeaderTypography';
import EmbeddedForm from './EmbeddedForm';

interface ScheduleDeviceSyncFormProps {
  entity: BulkActionEntity;
  onSave: (details: {}) => void;
}

const useStyles = makeStyles<Theme>(() => ({
  headerSpacing : {
    fontFamily    : 'roboto !important',
    fontWeight    : '500 !important' as any,
    textTransform : 'none !important' as 'none'
  },
  scheduleDeviceSync : {
    marginLeft : '22px',
    marginTop  : '10px',
    fontSize   : '14px'
  }
}));

/**
 * Re-usable form with the details for Schedule DeviceSync entity.
*/
export const ScheduleDeviceSyncForm = forwardRef(({
  entity,
  onSave
}: ScheduleDeviceSyncFormProps, ref) => {
  const classes       = useStyles();
  const {bulkActions} = translate('common:editors', {returnObjects: true});

  useImperativeHandle(ref, () => ({
    onSubmit : () => {
      onSave({});
    }
  }), [onSave]);

  return (
    <EmbeddedForm>
      <HeaderTypography variant={'h4'} className={classes.headerSpacing}>
        {bulkActions.dialogBulkAction.actionSelection.actionList.actions.scheduleDeviceSync}
      </HeaderTypography>
      <BodyTypography className={classes.scheduleDeviceSync}>
        {bulkActions.scheduleDeviceSync[entity]}
      </BodyTypography>
    </EmbeddedForm>
  );
});

export default memo(ScheduleDeviceSyncForm);
